import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';
import Button from '@mlb/react-patterns/components/Button/button.tsx';
import TextInput from '@mlb/react-patterns/components/TextInput/textInput.tsx';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 6px 10px 6px 2px;
    margin-bottom: 6px;
    background-color: ${COLORS.mlbGrey7};
    border: 1px solid ${COLORS.mlbGrey5};
    border-radius: 6px;
    box-sizing: border-box;
    align-items: center;
    font-family: ${FONTS.primaryFont};
`;

export const TextInputOverride = styled(TextInput)`
    &&& {
        width: 100%;
        cursor: pointer;
        input {
            flex-grow: 1;
            border: 0;
            background: 0 0;
            color: ${COLORS.mlbGrey1};
            font-family: ${FONTS.primaryFont};
            font-size: 12px;
            outline: 0;
            cursor: pointer;
            &::-ms-clear {
                display: none;
                width: 0;
                height: 0;
            }
        }
    }
`;

export const ButtonOverride = styled(Button)`
    &&& {
        flex-grow: 0;
        width: 60px;
        height: 22px;
        margin-left: 10px;
        background: ${(props) => props.copied ? COLORS.ticketGreen : COLORS.mlbGrey2};
        color: ${(props) => props.copied ? COLORS.mlbWhite : COLORS.mlbBlack};
        border: 0;
        font-family: ${FONTS.primaryFont};
        font-size: 9px;
        font-weight: 400;
    }
`;

const CopyInput = ({
    name,
    value,
    iconType,
    resetTimeout,
    ariaLabel,
    dictionary,
    onClick,
    lastModalNode,
    mediaPlayback,
}) => {

    const [
        copied,
        setCopied,
    ] = useState(false);

    const inputRef = React.useRef(null);

    const buttonText = copied 
        ? _get(dictionary, 'copied_text', 'Copied')
        : _get(dictionary, 'copy_text', 'Copy');

    return (
        <Wrapper
            onClick={() => {

                inputRef.current.select();
                document.execCommand('copy');
                setCopied(true);
                setTimeout(() => {

                    setCopied(false);
                
                }, resetTimeout);
                onClick({
                    type: name,
                    slug: _get(mediaPlayback, 'slug', ''),
                });
            
            }}
        >
            <TextInputOverride
                refElement={inputRef}
                value={value}
                iconType={iconType}
                ariaLabel={value}
                handlers={
                    {
                        onBlur: () => {

                            setCopied(false);
                        
                        },
                    }
                }
                additionalProps={
                    {
                        readOnly: true,
                    }
                }
            />
            <ButtonOverride
                ref={lastModalNode}
                label={buttonText}
                aria-pressed={copied}
                aria-label={`${buttonText} ${ariaLabel}`}
                copied={copied}
            />
        </Wrapper>
    );

};

CopyInput.propTypes = {
    lastModalNode: PropTypes.object,
    name: PropTypes.string,
    value: PropTypes.string,
    iconType: PropTypes.string,
    resetTimeout: PropTypes.number,
    ariaLabel: PropTypes.string,
    dictionary: PropTypes.object,
    onClick: PropTypes.func,
    mediaPlayback: PropTypes.object,
};

CopyInput.defaultProps = {
    lastModalNode: undefined,
    name: '',
    value: '',
    iconType: '',
    resetTimeout: 1500,
    ariaLabel: '',
    dictionary: {},
    onClick: _noop,
    mediaPlayback: {},
};

export default CopyInput;
